import React from 'react';
import { LeadCaptureForm } from '../../../components/forms/LeadCaptureForm';
import { FAQItem } from '../FAQItem';
import { HYROX_FAQS } from '../data';

export const FAQSection = () => (
  <section className="container-ninja section-spacing">
    <div className="max-w-4xl mx-auto">
      <h2 className="text-2xl text-white font-heading mb-6">Frequently Asked Questions</h2>
      {HYROX_FAQS.map((faq) => (
        <FAQItem key={faq.q} question={faq.q} answer={faq.a} />
      ))}
    </div>
  </section>
);

export const NewsletterSection = () => (
  <section className="bg-[#050505] section-spacing">
    <div className="container-ninja max-w-4xl">
      <LeadCaptureForm
        source="hyrox_hub"
        title="Get HYROX Training Tips"
        description="Weekly race strategies, workout plans, and equipment deals delivered to your inbox."
        buttonText="Join the HYROX Community"
        interests={['hyrox', 'fitness']}
      />
    </div>
  </section>
);
